import axios from "axios";

/**
 * Публичный axios-клиент — без токена.
 * Используется для входа, регистрации и восстановления пароля.
 */
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

const axiosPublicClient = axios.create({
  // Default to backend API base URL for public endpoints
  baseURL: API_BASE_URL ?? "",
  timeout: 300000, // 5 минут (300 секунд)
  headers: { "Content-Type": "application/json" },
});

export default axiosPublicClient;
